import { SplitButtonDesignTokens } from '@primeng/themes/types/splitbutton';

export default {
    root: {
        borderRadius: '{form.field.border.radius}',
        roundedBorderRadius: '2rem',
        raisedShadow: '0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)',
    },
    css: ({ dt }) => `
    .p-splitbutton-button {
        border: 1px solid ${dt('surface.0')} !important;
    }
    .p-splitbutton-dropdown {
        border: 1px solid ${dt('surface.0')} !important;
    }
    .p-splitbutton-button:hover {
        border: 1px solid ${dt('surface.0')} !important;
    }
    .p-splitbutton-dropdown:hover {
       border: 1px solid ${dt('surface.0')} !important;
    }
    `,
} as SplitButtonDesignTokens;
